import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconIncomplete$1 = /*@__PURE__*/ proxyCustomElement(class WppIconIncomplete extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-incomplete", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.99788 4C10.5502 4 10.9979 3.55228 10.9979 3C10.9979 2.44772 10.5502 2 9.99788 2C9.44559 2 8.99788 2.44772 8.99788 3C8.99788 3.55228 9.44559 4 9.99788 4ZM13.5249 5.14588C13.9717 5.47051 14.5971 5.37146 14.9217 4.92465C15.2463 4.47784 15.1473 3.85247 14.7005 3.52785C14.2536 3.20322 13.6283 3.30227 13.3036 3.74908C12.979 4.19589 13.0781 4.82126 13.5249 5.14588ZM16.9647 8.78791C16.4394 8.95858 15.8753 8.67113 15.7046 8.14587C15.5339 7.62062 15.8214 7.05646 16.3466 6.8858C16.8719 6.71513 17.436 7.00258 17.6067 7.52784C17.7774 8.05309 17.4899 8.61725 16.9647 8.78791ZM15.7037 11.8541C15.5331 12.3794 15.8205 12.9435 16.3458 13.1142C16.871 13.2849 17.4352 12.9974 17.6059 12.4722C17.7765 11.9469 17.4891 11.3828 16.9638 11.2121C16.4386 11.0414 15.8744 11.3289 15.7037 11.8541ZM13.3038 16.251C12.9792 15.8041 13.0782 15.1788 13.525 14.8542C13.9718 14.5295 14.5972 14.6286 14.9218 15.0754C15.2464 15.5222 15.1474 16.1476 14.7006 16.4722C14.2538 16.7968 13.6284 16.6978 13.3038 16.251ZM9.99788 16C9.44559 16 8.99788 16.4477 8.99788 17C8.99788 17.5523 9.44559 18 9.99788 18C10.5502 18 10.9979 17.5523 10.9979 17C10.9979 16.4477 10.5502 16 9.99788 16ZM5.07408 15.0753C5.3987 14.6285 6.02407 14.5295 6.47088 14.8541C6.91769 15.1787 7.01673 15.8041 6.69211 16.2509C6.36748 16.6977 5.74212 16.7968 5.29531 16.4722C4.8485 16.1475 4.74945 15.5222 5.07408 15.0753ZM4.29117 11.8541C4.1205 11.3289 3.55635 11.0414 3.0311 11.2121C2.50584 11.3828 2.21839 11.9469 2.38906 12.4722C2.55972 12.9974 3.12388 13.2849 3.64913 13.1142C4.17438 12.9435 4.46184 12.3794 4.29117 11.8541ZM3.64998 6.88579C4.17523 7.05645 4.46268 7.62061 4.29202 8.14586C4.12135 8.67111 3.5572 8.95856 3.03194 8.7879C2.50669 8.61723 2.21924 8.05308 2.3899 7.52783C2.56057 7.00257 3.12472 6.71512 3.64998 6.88579ZM6.47075 5.14585C6.91756 4.82122 7.0166 4.19585 6.69198 3.74905C6.36735 3.30224 5.74199 3.20319 5.29518 3.52782C4.84837 3.85244 4.74932 4.47781 5.07395 4.92462C5.39857 5.37143 6.02394 5.47047 6.47075 5.14585Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-incomplete-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-incomplete", "wpp-icon-incomplete-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-incomplete-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-incomplete-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconIncomplete$1);
      }
      break;
  } });
}

const WppIconIncomplete = WppIconIncomplete$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconIncomplete, defineCustomElement };
